import { render, staticRenderFns } from "./paySummary.vue?vue&type=template&id=987ebde6&scoped=true&"
import script from "./paySummary.vue?vue&type=script&lang=js&"
export * from "./paySummary.vue?vue&type=script&lang=js&"
import style0 from "./paySummary.vue?vue&type=style&index=0&id=987ebde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987ebde6",
  null
  
)

export default component.exports